import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Alert, Card, Col, Empty, Form, Input, Row, Table, Typography } from "antd";
import { GET_APP_OPERATOR_WISE_PERFORMANCE } from "apiServices/API_ENDPOINTS";
import { postData } from "apiServices/common";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { isArrayAndHasValue } from "utils/functions";
import "../style.css";
import ListTable from "common/ListTable";

// Define columns for the table
const columns = [
  { title: "Section", dataIndex: "name", key: "section_name" },
  {
    title: "Operator",
    dataIndex: ["operator_info"],
    key: "operator",
    render: (row, record) => {
      const operatorId = row?.id ?? record?.operator_emp_id;
      const operatorName = row?.name ?? record?.operator_name;
      const displayText = operatorId
        ? operatorName
          ? `${operatorId} : ${operatorName}`
          : `${operatorId}`
        : operatorName || "-";

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{displayText}</span>
          <span>
            {record?.performanceTier === "top" ? (
              <ArrowUpOutlined style={{ color: "#52c41a" }} />
            ) : (
              <ArrowDownOutlined style={{ color: "#eb2f96" }} />
            )}
          </span>
        </div>
      );
    },
  },
  {
    title: "Target",
    dataIndex: "target",
    key: "target",
  },
  {
    title: "Actual",
    dataIndex: "actual",
    key: "actual",
  },
  {
    title: "Variance",
    dataIndex: "vaiance",
    key: "section_table_variance",
  },
  {
    title: "% of Achieve",
    dataIndex: "acihive",
    key: "achieve",
    render: (value) =>
      value != null && !isNaN(value) ? Number(value).toFixed(2) : "-",
  },
  {
    title: "Place",
    dataIndex: "position",
    key: "place",
  },
];

const PERFORMANCE_SECTION_ORDER = [
  "MAKE SECTION",
  "BODY SECTION",
  "JOIN SECTION",
];

const normalizeSectionName = (name) =>
  name?.trim()?.replace(/\s+/g, " ")?.toUpperCase() ?? "";

const getPerformanceSections = (seactionTable) => {
  const sectionMap = new Map(
    (seactionTable ?? []).map((section) => [
      normalizeSectionName(section?.name),
      section,
    ]),
  );

  return PERFORMANCE_SECTION_ORDER.map((name) => sectionMap.get(name)).filter(
    Boolean,
  );
};

const getTopAndBottomPerformanceRows = (tableDatas) => {
  const rows = tableDatas ?? [];
  const topRows = rows
    .filter((row) => row.position >= 1 && row.position <= 3)
    .sort((a, b) => a.position - b.position);
  const bottomRows = [...rows]
    .filter((row) => row.position > 3)
    .sort((a, b) => b.position - a.position)
    .slice(0, 3);

  return [
    ...topRows.map((row) => ({ ...row, performanceTier: "top" })),
    ...bottomRows.map((row) => ({ ...row, performanceTier: "bottom" })),
  ];
};

const getPerformanceRowClassName = (record) => {
  if (record?.performanceTier === "top") {
    return "operator-performance-row-top";
  }
  if (record?.performanceTier === "bottom") {
    return "operator-performance-row-bottom";
  }
  return "";
};

const responseData = {
  code: 200,
  status: "success",
  message: "Data retrieved Successfully",
  data: {
    id: 10,
    name: "Line-11",
    styles: [
      {
        style_no: "469325A",
        id: 736,
        seaction_table: [
          {
            id: 5,
            name: "MAKE SECTION",
            table_datas: [
              {
                daily_line_plan_section_id: 6844,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 273,
                actual: 300,
                vaiance: -27,
                acihive: -9.89010989010989,
                position: 1,
              },
              {
                daily_line_plan_section_id: 6845,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 300,
                actual: 300,
                vaiance: 0,
                acihive: 0,
                position: 2,
              },
              {
                daily_line_plan_section_id: 6846,
                operator_emp_id: "4017859",
                operator_info: {
                  id: 2016,
                  name: "Md. Ibarahim Sarder Easan",
                  phone: "01912-435413",
                  email: "01912435413@cgl.com",
                },
                target: 214,
                actual: 300,
                vaiance: -86,
                acihive: -40.18691588785047,
                position: 3,
              },
              {
                daily_line_plan_section_id: 6848,
                operator_emp_id: "3905095",
                operator_info: {
                  id: 1889,
                  name: "Samsunnahar",
                  phone: "01945-820761",
                  email: "01945820761@cgl.com",
                },
                target: 167,
                actual: 250,
                vaiance: 83,
                acihive: 49.700598802395206,
                position: 18,
              },
              {
                daily_line_plan_section_id: 6859,
                operator_emp_id: "4011296",
                operator_info: {
                  id: 1975,
                  name: "Mst. Nargis Khatun ",
                  phone: "01730-631066",
                  email: "01730631066@cgl.com",
                },
                target: 162,
                actual: 260,
                vaiance: 98,
                acihive: 60.49382716049383,
                position: 17,
              },
              {
                daily_line_plan_section_id: 6861,
                operator_emp_id: "4019157",
                operator_info: {
                  id: 6001,
                  name: "Kakoli",
                  phone: "01607-647108",
                  email: "01607647108@cgl.com",
                },
                target: 194,
                actual: 100,
                vaiance: -94,
                acihive: -48.45360824742268,
                position: 16,
              },
            ],
          },
          {
            id: 1,
            name: "BODY SECTION",
            table_datas: [
              {
                daily_line_plan_section_id: 6844,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 273,
                actual: 300,
                vaiance: -27,
                acihive: -9.89010989010989,
                position: 1,
              },
              {
                daily_line_plan_section_id: 6845,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 300,
                actual: 300,
                vaiance: 0,
                acihive: 0,
                position: 2,
              },
              {
                daily_line_plan_section_id: 6846,
                operator_emp_id: "4017859",
                operator_info: {
                  id: 2016,
                  name: "Md. Ibarahim Sarder Easan",
                  phone: "01912-435413",
                  email: "01912435413@cgl.com",
                },
                target: 214,
                actual: 300,
                vaiance: -86,
                acihive: -40.18691588785047,
                position: 3,
              },
              {
                daily_line_plan_section_id: 6848,
                operator_emp_id: "3905095",
                operator_info: {
                  id: 1889,
                  name: "Samsunnahar",
                  phone: "01945-820761",
                  email: "01945820761@cgl.com",
                },
                target: 167,
                actual: 250,
                vaiance: 83,
                acihive: 49.700598802395206,
                position: 18,
              },
              {
                daily_line_plan_section_id: 6859,
                operator_emp_id: "4011296",
                operator_info: {
                  id: 1975,
                  name: "Mst. Nargis Khatun ",
                  phone: "01730-631066",
                  email: "01730631066@cgl.com",
                },
                target: 162,
                actual: 260,
                vaiance: 98,
                acihive: 60.49382716049383,
                position: 17,
              },
              {
                daily_line_plan_section_id: 6861,
                operator_emp_id: "4019157",
                operator_info: {
                  id: 6001,
                  name: "Kakoli",
                  phone: "01607-647108",
                  email: "01607647108@cgl.com",
                },
                target: 194,
                actual: 100,
                vaiance: -94,
                acihive: -48.45360824742268,
                position: 16,
              },
              {
                daily_line_plan_section_id: 6862,
                operator_emp_id: "4011207",
                operator_info: {
                  id: 1103,
                  name: "Mohammad Rezaul",
                  phone: "01706-938457",
                  email: "01706938457@cgl.com",
                },
                target: 188,
                actual: 125,
                vaiance: 63,
                acihive: 33.51063829787234,
                position: 1,
              },
              {
                daily_line_plan_section_id: 6862,
                operator_emp_id: "4011207",
                operator_info: {
                  id: 1103,
                  name: "Mohammad Rezaul",
                  phone: "01706-938457",
                  email: "01706938457@cgl.com",
                },
                target: 188,
                actual: 125,
                vaiance: -63,
                acihive: -33.51063829787234,
                position: 18,
              },
            ],
          },
          {
            id: 3,
            name: "JOIN SECTION",
            table_datas: [
              {
                daily_line_plan_section_id: 6844,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 273,
                actual: 300,
                vaiance: -27,
                acihive: -9.89010989010989,
                position: 1,
              },
              {
                daily_line_plan_section_id: 6845,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 300,
                actual: 300,
                vaiance: 0,
                acihive: 0,
                position: 2,
              },
              {
                daily_line_plan_section_id: 6846,
                operator_emp_id: "4017859",
                operator_info: {
                  id: 2016,
                  name: "Md. Ibarahim Sarder Easan",
                  phone: "01912-435413",
                  email: "01912435413@cgl.com",
                },
                target: 214,
                actual: 300,
                vaiance: -86,
                acihive: -40.18691588785047,
                position: 3,
              },
              {
                daily_line_plan_section_id: 6848,
                operator_emp_id: "3905095",
                operator_info: {
                  id: 1889,
                  name: "Samsunnahar",
                  phone: "01945-820761",
                  email: "01945820761@cgl.com",
                },
                target: 167,
                actual: 250,
                vaiance: 83,
                acihive: 49.700598802395206,
                position: 18,
              },
              {
                daily_line_plan_section_id: 6859,
                operator_emp_id: "4011296",
                operator_info: {
                  id: 1975,
                  name: "Mst. Nargis Khatun ",
                  phone: "01730-631066",
                  email: "01730631066@cgl.com",
                },
                target: 162,
                actual: 260,
                vaiance: 98,
                acihive: 60.49382716049383,
                position: 17,
              },
              {
                daily_line_plan_section_id: 6861,
                operator_emp_id: "4019157",
                operator_info: {
                  id: 6001,
                  name: "Kakoli",
                  phone: "01607-647108",
                  email: "01607647108@cgl.com",
                },
                target: 194,
                actual: 100,
                vaiance: -94,
                acihive: -48.45360824742268,
                position: 16,
              },
              {
                daily_line_plan_section_id: 6862,
                operator_emp_id: "4011207",
                operator_info: {
                  id: 1103,
                  name: "Mohammad Rezaul",
                  phone: "01706-938457",
                  email: "01706938457@cgl.com",
                },
                target: 188,
                actual: 125,
                vaiance: 63,
                acihive: 33.51063829787234,
                position: 1,
              },
              {
                daily_line_plan_section_id: 6862,
                operator_emp_id: "4011207",
                operator_info: {
                  id: 1103,
                  name: "Mohammad Rezaul",
                  phone: "01706-938457",
                  email: "01706938457@cgl.com",
                },
                target: 188,
                actual: 125,
                vaiance: -63,
                acihive: -33.51063829787234,
                position: 18,
              },
            ],
          },
          {
            id: 4,
            name: "LADIES",
            table_datas: [
              {
                daily_line_plan_section_id: 6844,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 273,
                actual: 300,
                vaiance: -27,
                acihive: -9.89010989010989,
                position: 1,
              },
              {
                daily_line_plan_section_id: 6845,
                operator_emp_id: "4014558",
                operator_info: {
                  id: 1991,
                  name: "Md. Rofiqul Islam ",
                  phone: "01770-160582",
                  email: "01770160582@cgl.com",
                },
                target: 300,
                actual: 300,
                vaiance: 0,
                acihive: 0,
                position: 2,
              },
              {
                daily_line_plan_section_id: 6846,
                operator_emp_id: "4017859",
                operator_info: {
                  id: 2016,
                  name: "Md. Ibarahim Sarder Easan",
                  phone: "01912-435413",
                  email: "01912435413@cgl.com",
                },
                target: 214,
                actual: 300,
                vaiance: -86,
                acihive: -40.18691588785047,
                position: 3,
              },
              {
                daily_line_plan_section_id: 6848,
                operator_emp_id: "3905095",
                operator_info: {
                  id: 1889,
                  name: "Samsunnahar",
                  phone: "01945-820761",
                  email: "01945820761@cgl.com",
                },
                target: 167,
                actual: 250,
                vaiance: 83,
                acihive: 49.700598802395206,
                position: 18,
              },
              {
                daily_line_plan_section_id: 6859,
                operator_emp_id: "4011296",
                operator_info: {
                  id: 1975,
                  name: "Mst. Nargis Khatun ",
                  phone: "01730-631066",
                  email: "01730631066@cgl.com",
                },
                target: 162,
                actual: 260,
                vaiance: 98,
                acihive: 60.49382716049383,
                position: 17,
              },
              {
                daily_line_plan_section_id: 6861,
                operator_emp_id: "4019157",
                operator_info: {
                  id: 6001,
                  name: "Kakoli",
                  phone: "01607-647108",
                  email: "01607647108@cgl.com",
                },
                target: 194,
                actual: 100,
                vaiance: -94,
                acihive: -48.45360824742268,
                position: 16,
              },
              {
                daily_line_plan_section_id: 6862,
                operator_emp_id: "4011207",
                operator_info: {
                  id: 1103,
                  name: "Mohammad Rezaul",
                  phone: "01706-938457",
                  email: "01706938457@cgl.com",
                },
                target: 188,
                actual: 125,
                vaiance: 63,
                acihive: 33.51063829787234,
                position: 1,
              },
              {
                daily_line_plan_section_id: 6862,
                operator_emp_id: "4011207",
                operator_info: {
                  id: 1103,
                  name: "Mohammad Rezaul",
                  phone: "01706-938457",
                  email: "01706938457@cgl.com",
                },
                target: 188,
                actual: 125,
                vaiance: -63,
                acihive: -33.51063829787234,
                position: 18,
              },
            ],
          },
        ],
        buyer_info: null,
      },
    ],
  },
};

export default function OperatorWisePerformance({
  line_id,
  date,
  currentSlide,
  slideId,
}) {
  const [searchParams] = useSearchParams();
  const effectiveDate = date || searchParams?.get("date");
  const formattedTime = moment().format("h:mm A");
  const formattedDate = effectiveDate
    ? moment(effectiveDate).format("DD-MMM-YYYY")
    : moment().format("DD-MMM-YYYY");

  const [records, setRecords] = useState([]);
  const [recordsLine, setRecordsLine] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchRecords = useCallback(
    async (filterValues) => {
      const query = `${GET_APP_OPERATOR_WISE_PERFORMANCE}`;

      setLoading(true);
      const payload = {
        line_id: line_id,
        ...(effectiveDate ? { date: effectiveDate } : {}),
      };
      const response = await postData(query, payload);
      setLoading(false);

      if (response && response?.code === 200) {
        const data = response?.data?.styles;
        let resData = isArrayAndHasValue(data) ? [...data] : [];
        setRecordsLine(response?.data?.name);
        setRecords(resData);
      }
    },
    [line_id, effectiveDate],
  );

  useEffect(() => {
    if (currentSlide === slideId && line_id) {
      fetchRecords();
    }
  }, [line_id, currentSlide, slideId, fetchRecords]);

  return (
    <div>
      <Card
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {loading ? (
          <ListTable
            loading
            columns={columns}
            dataSource={[]}
            pagination={false}
            bordered
            size="small"
            emptyText="No records to show yet."
          />
        ) : records.length > 0 ? (
          records.map((item, index) => (
            <div style={{ marginTop: "16px" }} key={index}>
              {index === 0 && (
                <Form layout="vertical">
                  <Row gutter={24} justify="end">
                    <Col span={24}>
                      <h2>Operator Wise Performance</h2>
                    </Col>
                    <Col span={2}>
                      <Form.Item label="Date">
                        <Input value={formattedDate} disabled />
                      </Form.Item>
                    </Col>

                    <Col span={2}>
                      <Form.Item label="Line">
                        <Input value={recordsLine} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Form.Item label="Time">
                        <Input value={formattedTime} disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              )}

              {/* <Form layout="vertical">
                <Row gutter={24} justify="end">
                  <Col span={4}>
                    <Form.Item label="Buyer">
                      <Input value={item?.buyer_info?.name} disabled />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label="Style">
                      <Input value={item?.style_no} disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </Form> */}

              {getPerformanceSections(item?.seaction_table).map((section, sIdx) => (
                <div
                  key={section?.id ?? section?.name ?? sIdx}
                  style={{ marginBottom: 24 }}
                >
                  <Typography.Title level={4} style={{ marginBottom: 12 }}>
                    {section?.name}
                  </Typography.Title>
                  <Table
                    className="operator-wise-performance-table"
                    dataSource={getTopAndBottomPerformanceRows(
                      section?.table_datas,
                    ).map((data) => ({
                      ...data,
                      name: section?.name,
                    }))}
                    columns={columns}
                    pagination={false}
                    bordered
                    rowClassName={getPerformanceRowClassName}
                    rowKey={(record, index) =>
                      record?.daily_line_plan_section_id
                        ? `${record.daily_line_plan_section_id}-${record.position ?? index}`
                        : index
                    }
                    size="small"
                  />
                </div>
              ))}
            </div>
          ))
        ) : (
          <Empty
            style={{
              width: "33%",
              margin: "auto",
              marginTop: "10%",
              marginBottom: "10%",
              height: "100%",
            }}
            description={
              <Alert
                message="No Data Found with selected line-id in Operator Wise Performance"
                type="warning"
              />
            }
          />
        )}
      </Card>
    </div>
  );
}
